import React, { useState, useEffect } from "react";
import { Grid, Menu } from "semantic-ui-react";
import { Link, useLocation } from "react-router-dom";
import {
  IoIosArrowDroprightCircle,
  IoIosArrowDropupCircle,
} from "react-icons/io";
import { userData } from "../pages/store/userData";
const SideBarComp = () => {
  const [expandState, setExpandState] = useState({});
  const location = useLocation();

  const userDetail = userData();
  useEffect(() => {
    const activeParentMenu = location.pathname.split("/")[1];
    if (activeParentMenu) {
      setExpandState((prevState) => ({
        ...prevState,
        [activeParentMenu]: true,
      }));
    }

    console.log("userDetail", userDetail);
  }, [location.pathname]);

  const handleParentMenuClick = (parentMenu) => {
    setExpandState((prevState) => ({
      ...prevState,
      [parentMenu]: !prevState[parentMenu],
    }));
  };

  const isChildMenuActive = (childMenu) => {
    return location.pathname.includes(childMenu);
  };

  const renderSubMenuItems = (subMenuItems) => {
    return subMenuItems.map((subMenuItem) => (
      <Menu.Item
        style={{ marginLeft: "20px" }}
        key={subMenuItem.name}
        as={Link}
        to={subMenuItem.to}
        active={isChildMenuActive(subMenuItem.name)}
      >
        {subMenuItem.name}
      </Menu.Item>
    ));
  };

  const renderParentMenuItem = (parentMenuItem) => {
    const { name, subMenuItems } = parentMenuItem;
    const isExpanded = expandState[name];

    if (!subMenuItems || subMenuItems.length === 0) {
      return (
        <Menu.Item
          key={name}
          as={Link}
          to={parentMenuItem.to}
          active={isChildMenuActive(parentMenuItem.name)}
        >
          {name}
        </Menu.Item>
      );
    }

    // if (name === "Create Company") {
    //   return (
    //     <Menu.Item onClick={() => handleParentMenuClick(name)}>
    //       {name}
    //       <span style={{ float: "right" }}>
    //         {isExpanded ? (
    //           <IoIosArrowDropupCircle />
    //         ) : (
    //           <IoIosArrowDroprightCircle />
    //         )}
    //       </span>
    //     </Menu.Item>
    //   );
    // }

    return (
      <React.Fragment key={name}>
        <Menu.Item onClick={() => handleParentMenuClick(name)}>
          {name}
          <span style={{ float: "right" }}>
            {isExpanded ? (
              <IoIosArrowDropupCircle />
            ) : (
              <IoIosArrowDroprightCircle />
            )}
          </span>
        </Menu.Item>
        {isExpanded && renderSubMenuItems(subMenuItems)}
      </React.Fragment>
    );
  };

  const menuData = [
    userDetail.dashboard == true && {
      name: "DASHBOARD",
      to: "/dashboard",
      subMenuItems: [],
    },
    userDetail.employee == true && {
      name: "EMPLOYEE",
      subMenuItems: [
        {
          name: "Create Employee",
          to: "/create-employee/null",
        },
        {
          name: "List Employee",
          to: "/list-employee",
        },
      ],
    },

    userDetail.companyEmployee == true && {
      name: "COMPANY EMPLOYEE",
      subMenuItems: [
        {
          name: "List Catogery",
          to: "/list-company-emp-catogery",
        },
        {
          name: "List Employee",
          to: "/list-company-employee/null",
        },
      ],
    },

    userDetail.company == true && {
      name: "COMPANY",
      subMenuItems: [
        {
          name: "List User",
          to: "/list-user",
        },
        {
          name: "Company List",
          to: "/company-list",
        },
      ],
    },

    userDetail.contact == true && {
      name: "CONTACT",
      subMenuItems: [
        {
          name: "List Catogery",
          to: "/list-contact-catogery",
        },
        {
          name: "List Contacts",
          to: "/list-contact-details/null",
        },
      ],
    },
    userDetail.invoice == true && {
      name: "INVOICE",
      subMenuItems: [
        {
          name: "List Catogery",
          to: "/list-invoice-catogery",
        },
        {
          name: "Work Name List",
          to: "/list-invoice-workname",
        },
        {
          name: "List Invoice Item",
          to: "/list-invoice-item",
        },
        {
          name: "List Invoice",
          to: "list-invoice/null",
        },
      ],
    },

    userDetail.invoiceIndia == true && {
      name: "INVOICE (INDIA)",
      subMenuItems:
        userDetail.userRole === 1
          ? [
              {
                name: "List Catogery (INDIA)",
                to: "/list-invoice-india-catogery",
              },
              {
                name: "Work Name List (INDIA)",
                to: "/list-invoice-india-workname",
              },
              {
                name: "List Invoice Item (INDIA)",
                to: "/list-invoice-india-item",
              },
              {
                name: "List Invoice (INDIA)",
                to: "list-india-invoice/null",
              },
              {
                name: "All Attractions",
                to: "/list-performa-invoice",
              },
            ]
          : [
              {
                name: "List Invoice (INDIA)",
                to: "list-india-invoice/null",
              },
              {
                name: "All Attractions",
                to: "/list-performa-invoice",
              },
            ],
    },
    userDetail.receiveMoney == true && {
      name: "RECEIVE MONEY",
      subMenuItems: [
        {
          name: "List Catogery",
          to: "/recive-money-catogery",
        },
        {
          name: "List Receive Money",
          to: "/list-recive-money/null",
        },
      ],
    },
    userDetail.spendMoney == true && {
      name: "SPEND MONEY",
      subMenuItems: [
        {
          name: "List Catogery",
          to: "/spend-money-catogery",
        },
        {
          name: "List Spend Money",
          to: "/list-spend-money/null",
        },
      ],
    },
    userDetail.purchaseDetail == true && {
      name: "PURCHASE DETAIL",
      subMenuItems: [
        {
          name: "Purchase Category List",
          to: "/purchase-category-list",
        },
        {
          name: "Purchase List",
          to: "/purchase-list/null",
        },
      ],
    },
    userDetail.dailyWork == true && {
      name: "DAILY WORK",
      subMenuItems: [
        {
          name: "Daily Work Category",
          to: "/daily-work-category",
        },
        {
          name: "Daily For Name List",
          to: "/list-dailywork-forname",
        },
        //list-dailywork-forname
        {
          name: "Daily Work List",
          to: "/daily-work-list/null",
        },
      ],
    },
    userDetail.createCompany == true && {
      name: "CREATE COMPANY",
      subMenuItems: [
        {
          name: "List Catogery",
          to: "/new-company-catogery",
        },
        {
          name: "company List ",
          to: "/list-company-newFormet",
        },

        {
          name: "company details ",
          to: "/create-company-new",
        },
      ],
    },
    userDetail.createVisa == true && {
      name: "CREATE VISA",
      subMenuItems: [
        {
          name: "Visa Category List ",
          to: "/list-visa-category",
        },
        {
          name: "Visa List ",
          to: "/list-visa-all/null",
        },
      ],
    },

    userDetail.customerVisa == true && {
      name: "CREATE CUSTOMER VISA",
      subMenuItems: [
        {
          name: "Cutomer Visa Category List ",
          to: "/list-cus-visa-category",
        },
        {
          name: "Cutomer Visa List ",
          to: "/list-cus-visa-all/null",
        },
      ],
    },

    userDetail.fleetMgnt == true && {
      name: "FLEET MANAGMENT ",
      subMenuItems: [
        {
          name: "Tour List ",
          to: "/tour-list",
        },
        {
          name: "Vehicle List ",
          to: "/vehile-list",
        },
      ],
    },
    userDetail.ticketImventory == true && {
      name: "TICKET INVENTORY",
      subMenuItems: [
        {
          name: "Attraction List",
          to: "/attractopn-caregory-list/null",
        },
        {
          name: "Ticket Type List",
          to: "/tickettype-caregory-list/null",
        },
        {
          name: "Ticket Data ",
          to: "/list-ticket-data-all/null",
        },
      ],
    },
    // userDetail.ticketImventory == true && {
    //   name: "TOUR PACKAGE IVOICE",
    //   subMenuItems: [
    //     {
    //       name: "Tour Package List",
    //       to: "/tour-package-inoice-list/null",
    //     },

    //   ],
    // },
    userDetail.tourInvoice == true && {
      name: "TOUR PACKAGE IVOICE",
      subMenuItems: [
        {
          name: "Tour Package Hotel",

          to: "/tour-package-hotel-list-new",
        },
        {
          name: "Tour Package Items",

          to: "/tour-package-items-list-new",
        },
        {
          name: "Tour Package Category",
          // to: "/create-tour-package-category-new/null",
          to: "/tour-package-category-list-new",
        },
        {
          name: "Tour Package List",
          to: "/tour-package-list-new/null",
        },
      ],
    },

    userDetail.dataEntry == true && {
      name: "DATA ENTRY",
      subMenuItems: [
        {
          name: "Data Entry Catogery",

          to: "/data-inv-catogery-list",
        },
        {
          name: "Data Entry List",

          to: "/data-inv-new-list/null",
        },
      ],
    },

    userDetail.dataEntryindia == true && {
      name: "DATA ENTRY INDIA",
      subMenuItems: [
        {
          name: "Data Entry Catogery",

          to: "/data-inv-catogery-india-list",
        },
        {
          name: "Data Entry List",

          to: "/data-inv-new-india-list/null",
        },
      ],
    },

    userDetail.dataEntryindia == true && {
      name: "DAILY ENTRY",
      subMenuItems: [
        {
          name: "Catogery List",

          to: "/daily-entry-catogery-list",
        },
        {
          name: "Company List",

          to: "/daily-entry-company-list",
        },
        {
          name: "Ticket Type List",

          to: "/daily-entry-ticket-type-list",
        },
        {
          name: "Recived Bank List",

          to: "/daily-entry-recived-bank-list",
        },
        {
          name: "Daily Entry List",
          to: "/daily-entry-data-list",
        },
      ],
    },
    // {
    //   name: "Create Catogery",
    //   subMenuItems: [
    //     {
    //       name: "Category List ",
    //       to: "/list-all-category",
    //     },
    //   ],
    // },
  ];

  return (
    <Grid.Column
      tablet={3}
      computer={3}
      only="tablet computer"
      id="sidebar"
      style={{
        // minHeight: "calc(100vh - 10px)", // Adjust the height as needed
        overflowY: "auto",
      }}
    >
      <Menu vertical borderless fluid text>
        {menuData.map((menuItem) => (
          <React.Fragment key={menuItem.name}>
            {renderParentMenuItem(menuItem)}
          </React.Fragment>
        ))}
      </Menu>
    </Grid.Column>
  );
};

export default SideBarComp;
